import React from "react";
import { TestReport } from "../../types/TestReport";
import { DefaultCell, Icon, ProgressRadial, Table } from "@itwin/itwinui-react";
import styles from "./TestReport.module.css";
import { SvgStatusError, SvgStatusSuccess, SvgStatusWarning } from "@itwin/itwinui-icons-react";
import { Column, Row } from "react-table";

interface TestReportProps {
  report?: TestReport[];
  className?: string;
}

const ErrorMessageComponent = (row: Row<TestReport>) => {
  let message = JSON.stringify(row.original.error, Object.getOwnPropertyNames(row.original.error ?? {}), 4);
  message = message?.replaceAll("\\n", "\n\t");

  return row.original.error
    ? <pre className={styles['error-message']}><small>{message}</small></pre>
    : null
};

export const TestReportViewer = ({ report, className }: TestReportProps) => {

  const columns: Column<TestReport>[] = React.useMemo(
    () => [
      {
        id: "title",
        Header: "Name",
        accessor: "title"
      },
      {
        id: "state",
        Header: "Status",
        accessor: "state",
        maxWidth: 150,
        cellRenderer:
          ((props) =>
            <DefaultCell
              {...props}
              startIcon={
                props.cellProps.row.original.state === "failed"
                  ? <Icon fill="negative"><SvgStatusError className="error" /></Icon>
                  : props.cellProps.row.original.state === "pending"
                    ? <ProgressRadial indeterminate />
                    : props.cellProps.row.original.state === "passed"
                      ? <Icon fill="positive"><SvgStatusSuccess /></Icon>
                      : <Icon fill="warning"><SvgStatusWarning /></Icon>
              }
            />
          )
      },
      {
        id: "duration",
        Header: "Duration",
        accessor: "duration",
        maxWidth: 150,
        Cell: (props) => {
          return `${props.row.original.duration} ms`
        }
      },
    ], []);

  return (
    <div className={[className ?? "", styles.container].join(" ")}>
      <Table
        columns={columns}
        emptyTableContent="No data."
        data={report ?? []}
        density="condensed"
        subComponent={ErrorMessageComponent}
      />
    </div>
  )
}